import type {
  LockedTrackerInstance,
  TrackerConfig,
} from 'usage-tracker-core/trackerTypes';

import { normalizePath } from './normalizePath';

const NAMESPACE = 'Business Units Lib';
const EVENT_NAME = 'Select Changed';
const DEFAULT_BRAND_SAVED_EVENT_NAME = 'Default Brand Saved';

export type EventProperties = {
  screen: string;
  subscreen?: string;
  path?: never;
};

export function createBusinessUnitSelectChangeTracker<C extends TrackerConfig>(
  trackerInstance: LockedTrackerInstance<C>
) {
  const newTracker: LockedTrackerInstance<{ standalone: true }> =
    trackerInstance.clone({
      standalone: true,
      preserveTrackerEvents: false,
      preserveTrackerProperties: false,
    });

  return (properties?: EventProperties) => {
    newTracker.track(NAMESPACE, EVENT_NAME, {
      ...properties,
      path: normalizePath(window.location.pathname),
    });
  };
}

export function createDefaultBrandSavedTracker<C extends TrackerConfig>(
  trackerInstance: LockedTrackerInstance<C>
) {
  const newTracker: LockedTrackerInstance<{ standalone: true }> =
    trackerInstance.clone({
      standalone: true,
      preserveTrackerEvents: false,
      preserveTrackerProperties: false,
    });

  return () => {
    newTracker.track(NAMESPACE, DEFAULT_BRAND_SAVED_EVENT_NAME, {
      screen: normalizePath(window.location.pathname),
    });
  };
}
